module.exports = __webpack_public_path__ + "3fff277749467beafaf1383f0d3d2f6b.png";